module.exports = __webpack_public_path__ + "static/media/IMG_1560.836c0d6d.JPG";